/**
 * @function browserClasses
 * @description sets up browser classes on body without using user agent strings where possible.
 */

const activateJS = () => {
	document.body.classList.add('js-active')
}

export default activateJS
